import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BaseRepository } from '../../Common/Data/base.repository';
import { Observable } from 'rxjs';

@Injectable()
export class TaxDotComDocsSvcLogRepository extends BaseRepository {
    constructor(httpClient: HttpClient) {
        super(httpClient);
    }

    getList(searchModel: Core.TaxDotComDocsSvcSummaryLogSearchModel): Observable<Compliance.QueryResultModel<Core.TaxDotComDocsSvcSummaryLogModel>> {
        return this.httpPost('/api/diagnostics/taxDotComDocsSvc/summary', searchModel);
    }

    getDetail(searchModel: Core.TaxDotComDocsSvcDiagnosticsDetailSearchModel): Observable<Core.TaxDotComDocsSvcDiagnosticsDetailModel> {
        return this.httpPost(`/api/diagnostics/taxDotComDocsSvc/detail`, searchModel);
    }
}
